import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../store/store';
import { BRAND_BILLING_TYPES } from '../../../store/brand/reducer';
import { batch, connect } from 'react-redux';

import { ArrowDown as ICON_ARROW_DOWN } from 'react-feather';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  SortEndHandler,
} from 'react-sortable-hoc';

import API from '../../../api';
import { ROUTES } from '../../../routes';

import PaymentCreate from '../../payments/create';
import PaymentComplete from '../../payments/complete';
import { debounce } from '../../../helpers/debounce';

import BottomGradient from '../../../components/bottomGradient';
import LoadingText from '../../../components/loadingText';
import Button from '../../../components/button';
import './styles.css';
import { useLanguage } from '@languages/index';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';

const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY);

interface SortableItemProps {
  value: any;
}

interface SortableListProps {
  items: any[];
  onSortEnd: SortEndHandler;
}

const DragHandle = SortableHandle(() => <span></span>);

const SortableItem = SortableElement<SortableItemProps>(({ value }) => (
  <div className="sortable-item">
    <img
      className="object-cover aspect-[0.7825] w-full h-full"
      src={value.images[0].thumbSmUrl}
    />
    <DragHandle />
  </div>
));

const SortableList = SortableContainer<SortableListProps>(({ items }) => (
  <div className="grid grid-cols-3 grid-flow-row gap-[14px] w-full">
    {items.map((value, index) => (
      <SortableItem key={`item-${index}`} index={index} value={value} />
    ))}
  </div>
));

const SNSPostingOrderUpdate = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const navigate = useNavigate();

  const storeSnsPass = () => {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH, {
      replace: true,
    });
  };

  const [postingsOriginal, setPostingsOriginal] = useState();
  const [postings, setPostings] = useState<any>();
  const [isUpdated, setIsUpdated] = useState(false);
  const postingPage = useRef(1);
  const postingsCount = useRef(0);

  const [isFetching, setIsFetching] = useState(false);
  const [isContentEnded, setIsContentEnded] = useState(false);
  // useInfiniteScroll(() => {
  //   if (isContentEnded) {
  //     return false;
  //   }

  //   if (postings && postings.length) {
  //     fetchPostings();
  //     return false;
  //   }
  // });

  const [isPublishedFiltered, setIsProvidedFiltered] = useState('true');

  const fetchPostings = (refresh?) => {
    if (refresh) {
      postingPage.current = 1;
      setPostings(undefined);
    }

    setIsFetching(true);

    API.Post.index({
      brandToken: props.auth.token,
      brandId: props.brand.id,
      page: postingPage.current,
      isPublished: isPublishedFiltered,
      isSns: true,
    })
      .then((response) => {
        batch(() => {
          postingsCount.current = response.data.count;

          const postingsArr =
            postingPage.current === 1
              ? response.data.postings
              : postings.concat(response.data.postings);

          setPostings(postingsArr);
          setPostingsOriginal(postingsArr);
          setIsContentEnded(
            response.data.paginator.currentPage ==
              response.data.paginator.lastPage,
          );

          setIsFetching(false);

          postingPage.current = postingPage.current + 1;
        });
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  useEffect(() => {
    fetchPostings(true);
  }, [isPublishedFiltered]);

  useEffect(() => {
    if (JSON.stringify(postingsOriginal) != JSON.stringify(postings)) {
      setIsUpdated(true);
    } else {
      setIsUpdated(false);
    }
  }, [postings]);

  const renderLoadingIndicator = () => {
    return isFetching && !isContentEnded ? (
      <div className="flex flex-row mx-10 my-10 justify-center items-center">
        <div className="flex flex-row justify-center text-center my-5">
          <span className="prose prose-xl text-slate-400">
            {languageTexts.loading_1}
          </span>
        </div>
      </div>
    ) : null;
  };

  const showPaymentCompleteModal = (
    targetProductType,
    amount,
    price,
    priceTotal,
  ) => {
    setTimeout(() => {
      props.showOverlays({
        content: () => {
          return (
            <PaymentComplete
              // title={languageTexts.payment_history2}
              itemType={targetProductType}
              // amount={amount}
              // price={price}
              // priceTotal={priceTotal}
              onConfirm={() => {
                props.closeOverlays();
              }}
            />
          );
        },
      });
    }, 400);
  };

  const proceedPayment = () => {
    let amount = undefined;
    let price = undefined;
    let priceTotal = undefined;

    props.closeOverlays();

    const targetProductType = props.brand?.hasExperiencedSnsInstall
      ? PAYMENT_PRODUCT_TYPE.SNS_PASS
      : PAYMENT_PRODUCT_TYPE.SNS_INSTALL;

    switch (targetProductType) {
      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
        amount = 1;
        price = props.brand.priceSnsPass;
        priceTotal = null;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        amount = 1;
        price = props.brand.priceSnsPass;
        priceTotal = props.brand.priceSnsPass + props.brand.priceSnsInstall;
        break;
    }

    debounce(() => {
      if (
        props.brand.remainSnsPass ||
        props.brand.billingType == BRAND_BILLING_TYPES.FREE
      ) {
        // storeCampaign();
      } else {
        props.showOverlays({
          content: () => {
            return (
              <Elements stripe={stripePromise}>
                <PaymentCreate
                  itemType={targetProductType}
                  amount={amount}
                  price={price}
                  priceTotal={priceTotal}
                  onSuccess={() => {
                    showPaymentCompleteModal(
                      targetProductType,
                      amount,
                      price,
                      priceTotal,
                    );

                    storeSnsPass();
                  }}
                />
              </Elements>
            );
          },
        });
      }
    }, 400);
  };

  useEffect(() => {
    if (
      props.brand?.hasExperiencedSnsInstall &&
      !props.brand?.snsPassInstalledAt
    ) {
      navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
    }
  }, []);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setPostings((prevItems) => {
      const newItems = [...prevItems];
      const [movedItem] = newItems.splice(oldIndex, 1);
      newItems.splice(newIndex, 0, movedItem);
      return newItems;
    });
  };

  const renderSnsSection = () => {
    if (!props.brand?.hasExperiencedSnsInstall) {
      return null;
    }

    if (!props.brand?.snsPassInstalledAt) {
      return null;
    }

    return (
      <div className="flex flex-col justify-center">
        <div className="w-full max-w-[1025px] my-[4.25rem] mx-auto">
          <div className="flex flex-row">
            <span className="font-bold text-[1.375rem]">
              {languageTexts.order_postings_text_1}
            </span>
          </div>

          <div className="flex flex-col my-[1.875rem] gap-[1.5rem]">
            <div className="flex flex-row justify-between">
              <div>
                <span className="text-[0.9375rem]">
                  {languageTexts._order_postings_text_2()}
                </span>
              </div>
            </div>

            <div className="flex flex-row gap-10"></div>

            <div className="flex flex-row px-[1rem] pt-[2.25rem] sm:px-0">
              {postings && postings.length == 0 ? (
                <div className="py-[12rem] mx-auto">
                  <span className="font-bold text-[1.375rem] text-[#E8E8E8]">
                    {languageTexts.order_postings_text_3}
                  </span>
                </div>
              ) : (
                <>
                  {postings && postings.length ? (
                    <SortableList
                      items={postings}
                      onSortEnd={onSortEnd}
                      axis="xy"
                    />
                  ) : null}
                </>
              )}
            </div>

            {isFetching || isContentEnded ? null : (
              <div className="flex flex-row">
                <Button
                  className={'px-3 py-[22.5px] md:py-3 text-center select-none'}
                  textColor={'black'}
                  buttonColor={'white'}
                  borderColor={'#888'}
                  text={languageTexts.show_more}
                  onClick={() => {
                    if (isFetching) return;
                    fetchPostings();
                  }}
                />
              </div>
            )}

            <div className="mt-[2.25rem]"></div>
          </div>

          {renderLoadingIndicator()}
        </div>
      </div>
    );
  };

  const saveOrder = async () => {
    props.showModal({
      hideCloseButton: true,
      hideConfirmButton: true,
      content: () => {
        return (
          <div className="font-bold text-3xl text-white select-none">
            <LoadingText
              text={languageTexts.order_postings_text_4}
              render={(text) => {
                return <span>{text}</span>;
              }}
            />
          </div>
        );
      },
    });

    const orderedPostings = postings.map((item, index) => {
      return { ...item, orderSns: index };
    });

    await API.SnsPosting.updateOrder({
      brandToken: props.auth.token,
      postings: orderedPostings,
    })
      .then((response) => {
        props.showModal({ text: response.message });
        fetchPostings(true);
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  const renderSaveButton = () => {
    return (
      <div className="flex flex-col fixed w-full left-0 right-0 bottom-0 bg-red-400 justify-between">
        <div className="hidden md:flex">
          <BottomGradient />
        </div>

        <div className="fixed md:w-[240px] bottom-0 left-0 right-0 md:mx-auto form-submit-button md:rounded-sm md:mb-6 z-[2]">
          <Button
            className={'px-3 py-[22.5px] md:py-3 text-center'}
            textColor={'WHITE'}
            buttonColor={'BLACK'}
            borderColor={'BLACK'}
            text={languageTexts.order_postings_text_5}
            onClick={() => {
              if (isFetching) {
                return;
              }
              saveOrder();
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {renderSnsSection()}
      {renderSaveButton()}
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchProps,
)(SNSPostingOrderUpdate);
